import { Component, EventEmitter, Inject, Input, LOCALE_ID, Output } from '@angular/core';
import { DealerDocument } from '../../models/dealer.document.interface';
import { QuoteService } from '../../../quote/services/quote.service';

@Component({
  selector: 'app-dealer-document-selection',
  templateUrl: './dealer-document-selection.component.html',
  styleUrls: ['./dealer-document-selection.component.scss']
})
export class DealerDocumentSelectionComponent {
  locale: string = 'en';
  
  isRequesting: boolean = false;
  selectedDocumentIds: number[] = [];
  dealerDocuments: DealerDocument[] = [];

  selectedDocuments: DealerDocument[] = [];
  errors: string;

  @Output() selectionUpdated = new EventEmitter<DealerDocument[]>();
  @Output() documentsLoaded = new EventEmitter<DealerDocument[]>();
  constructor(private quoteService: QuoteService, @Inject(LOCALE_ID) locale: string) {

    this.locale = locale;
    this.getDealerDocuments();
  }

  getDealerDocuments(): void {
    this.isRequesting = true;
    this.quoteService.getDealerDocuments(true)
      .subscribe({
        next: (result) => {
          this.isRequesting = false;          
          this.dealerDocuments = result;
        },
        error: (error: string) => {
          this.errors = error;
        },
        complete: () => {
          this.isRequesting = false;
          this.documentsLoaded.emit(this.dealerDocuments);
          return;
        }
      });
  }

  selectionChanged(document: DealerDocument): void {
    // if the item is in the array, remove it... otherwise add it
    if (this.selectedDocumentIds.includes(document.dealerDocument_ID)) {
      let itemToRemoveIndex = this.selectedDocumentIds.indexOf(document.dealerDocument_ID)
      if (itemToRemoveIndex != undefined) { this.selectedDocumentIds.splice(itemToRemoveIndex, 1) }
    }
    else {
      this.selectedDocumentIds.push(document.dealerDocument_ID);
    }

    this.selectedDocuments.length = 0;
    this.dealerDocuments.forEach(dd => {
      if (this.selectedDocumentIds.indexOf(dd.dealerDocument_ID) != -1)
        this.selectedDocuments.push(dd);
    });

    this.selectionUpdated.emit(this.selectedDocuments);
  }

}
